export default __webpack_public_path__ + "static/media/shower.c6212240.png";